// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nrYkw","largestCol":"styles_largestCol__3tw0g","smallestCol":"styles_smallestCol__1rctu"};